import React, {useCallback, useEffect, useState} from "react";
import { AddOutline } from 'antd-mobile-icons'
import {useNavigate} from "react-router-dom";
import {getLoginUserInfo, TOASTDURATION} from "../../common/Utils";
import {deleteOrder, hubtelCheckMsisdn, orderList} from "../../common/ApiAction";
import {Button, Empty, Space, Toast} from "antd-mobile";
import {useTranslation} from "react-i18next";

const HomePage = () => {
    const [list, setList] = useState<any[]>([]);
    const navigate = useNavigate();
    const isHebtel = process.env.REACT_APP_ENV === 'production02';
    const { t } = useTranslation();

    /**
     * Action
     */
    const _getWebData = useCallback(() => {
        let userInfo: API.CurrentUser | null = getLoginUserInfo();
        if (userInfo) {
            const postData = {
                id: userInfo.id
            }
            Toast.show({icon: 'loading', content: 'Login...', duration: 0})
            orderList(postData).then((res: any) => {
                Toast.clear();
                if (!res.executed) {
                    Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
                } else {
                    setList(res.data);
                }
            }).catch((err: any) => {
                Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
            })
        } else {
            Toast.show({
                icon: 'fail', content: "NOT LOGIN MESSAGE", duration: TOASTDURATION, afterClose: () => {
                    navigate('/login')
                }
            })
        }
    }, [navigate])
    useEffect(()=> {
        _getWebData();
    },[_getWebData])

    const _deleteOrder = (orderNo: string, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation()
        deleteOrder({orderNo: orderNo}).then((r: any) => {
            if (!r.executed) {
                Toast.show({icon: 'fail', content: r.message, duration: TOASTDURATION})
            } else {
                Toast.show({icon: 'success', content: "Delete Success!", duration: TOASTDURATION})
                _getWebData();
            }
        })
    }
    const _preapprovalHubtel = (item: any, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation()
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        hubtelCheckMsisdn(item.userInfo.mobile).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                navigate('/hubtel/details', {state: res.data});
            } else {
                const data = {
                    orderNo : item.orderInfo.orderNo,
                    customerMsisdn: item.userInfo.mobile,
                    customerName: item.userInfo.userName
                }
                navigate('/hubtel/create', {state: data});
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
        // navigate('/preapprovalHubtel', {state: item});
    }
    const _modifyOrder = (item: any, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation()
        navigate('/editOrder', {state: item});
    }
    const addDidClick = () => {
        navigate('/createOrder');
    }
    const listItemDidClick = (item: any) => {
        navigate('/detailOrder', {state: item});
    }
    const _renderHeader = () => {
        return <div
            onClick={addDidClick}
            style={{display: "flex", flexDirection: "row-reverse", paddingRight: 30, paddingTop: 15,paddingBottom: 15}}>
            <AddOutline fontSize={36} color={'#494BFF'}/>
        </div>
    }
    const _renderItemUI = (title: string, data: any) => {
        return <div className={'item-box'} style={{padding: '7px 0'}}>
            <span>{title}</span>
            <span>{data}</span>
        </div>
    }
    const _getOrderStatusDesc = (status: number) => {
        if (status === 0) {
            return t('home_order_pending'); // 使用翻译
        } else if (status === 2) {
            return t('home_order_settled'); // 使用翻译
        } else if (status === 3) {
            return t('home_order_overdue'); // 使用翻译
        }
        return '';
    }
    const _renderListUI = () => {
        if (list.length) {
            return <div>
                {list.map((item,index) => {
                    return <div key={index} className={'home-list'} onClick={() => listItemDidClick(item)}>
                        <div className={'item-box'} style={{padding: '14px 0'}}>
                            <span>{item.orderInfo.orderNo}</span>
                            <span>{_getOrderStatusDesc(item.orderInfo.status)}</span>
                        </div>
                        <div style={{backgroundColor: '#EFEFEF', width: '100%', height: 1}}/>
                        {_renderItemUI(t('home_user'), item.userInfo.userName)}
                        {_renderItemUI(t('home_product'), item.productInfo.model)}
                        {_renderItemUI(t('home_down_payment'), item.orderInfo.downPayment)}
                        {_renderItemUI(t('home_periods'), item.orderInfo.periods)}
                        {_renderItemUI(t('home_submission_time'), item.orderInfo.rawCreateTime)}
                        {item.orderInfo.status === 0 ? <div style={{display: "flex", flexDirection: "row-reverse", padding: '10px 0'}}>
                            <Space>
                                <Button onClick={(event) => _deleteOrder(item.orderInfo.orderNo, event)} color='danger' fill='outline'>{t('home_delete')}</Button>
                                <Button onClick={(event) => _modifyOrder(item, event)} color='primary' fill='outline'>{t('common_modify')}</Button>
                            </Space>
                        </div> : null}
                        {item.orderInfo.status === 7 ? <div>
                            {_renderItemUI(t('common_status'), t('approval_not_pass'))}
                            {_renderItemUI(t('common_remarks'), item.approvalInfo ? item.approvalInfo.remarks : '')}
                            <div style={{display: "flex", flexDirection: "row-reverse", padding: '10px 0'}}>
                                <Button onClick={(event) => _modifyOrder(item, event)} color='primary' fill='outline'>{t('common_modify')}</Button>
                            </div>
                        </div> : null}
                        {isHebtel ? <div style={{display: "flex", flexDirection: "row-reverse", padding: '15px 0'}}>
                            <Button onClick={(event) => _preapprovalHubtel(item, event)} color='primary' fill='outline'>Preapproval Hubtel Manage</Button>
                        </div> : null}
                    </div>
                })}
            </div>
        }
        return <div>
            <Empty description='No Data'/>
        </div>
    }
    return <div style={{display: "flex", flexDirection: "column", width: '100%'}}>
        {_renderHeader()}
        {_renderListUI()}
    </div>
}
export default HomePage;
